import { Link } from 'react-router-dom';
import { INDUSTRIES } from '../data/site';
import { Seo } from '../lib/seo';
import { Reveal } from '../components/motion';
import { PageHero, CTABand } from '../components/chrome';

const crumbs = [{ label: 'Home', href: '/' }, { label: 'Industries' }];

export default function IndustriesHub() {
  return (
    <div data-testid="page-industries-hub">
      <Seo
        title="Industries Served: Government, Healthcare, Environmental & Research Labs | ToxGlobal Analytics"
        description="ToxGlobal Analytics equips federal and DoD laboratories, VA healthcare, environmental and forensic programs, universities, pharma, chemical, manufacturing, and industrial hygiene operations nationwide."
        path="/industries"
        breadcrumbs={crumbs}
      />
      <PageHero
        eyebrow="Industries"
        lines="Ten sectors. One accountable supplier."
        sub="From federal laboratories to manufacturing QC, each industry page maps the equipment categories and services that fit the mission — with procurement workflows to match."
        breadcrumbs={crumbs}
        image={INDUSTRIES[0].image}
        imageAlt={INDUSTRIES[0].alt}
      />
      <section className="section-pad">
        <div className="container-x grid sm:grid-cols-2 gap-px bg-slate-200 border border-slate-200">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.slug} delay={Math.min(i * 0.04, 0.3)} className="bg-white">
              <Link to={`/industries/${ind.slug}`} className="group flex h-full" data-testid={`industry-card-${ind.slug}`}>
                <div className="hidden sm:block w-40 lg:w-52 shrink-0 overflow-hidden bg-midnight">
                  <img src={ind.image} alt={ind.alt} loading="lazy" className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6 sm:p-8 grow">
                  <p className="font-mono text-[11px] text-slate-400 tabular">{String(i + 1).padStart(2, '0')}</p>
                  <h2 className="display text-xl sm:text-2xl text-ink mt-2 group-hover:text-signal transition-colors">{ind.name}</h2>
                  <p className="mt-2 text-sm text-slate-500 leading-relaxed">{ind.tagline}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <CTABand />
    </div>
  );
}
